import React from 'react'
import { Message } from 'semantic-ui-react'

class Mensagem extends React.Component {



    render() {

        let classtoastr = this.props.toastr || this.props.toastr=== true ? 'toastr' : '';

        return <Message
            error={(this.props.error || this.props.error === true)}
            warning={(this.props.warning || this.props.warning === true)}
            success={(this.props.success || this.props.success === true)}
            info={(this.props.info || this.props.info === true)}
            positive={(this.props.positive || this.props.positive === true)}
            negative={(this.props.negative || this.props.negative === true)}
            className={`resetCorners resetBorders ${classtoastr}`}>
            <Message.Header>{this.props.Header} </Message.Header>
            <Message.Content>{this.props.Content}</Message.Content>

            {(this.props.list && this.props.list.length > 0) &&
                <Message.List as='div'>                    
                    {this.props.list.map(i=>                        
                        (<Message.Item key={i} as='div'>{i}</Message.Item>)
                    )}
                </Message.List>
            }
        </Message>
    }
}

export default Mensagem






// WEBPACK FOOTER //
// ./src/components/Sistema/Mensagem.js